import React, { memo } from 'react';
import { TestDetailQuizModel, TestQuestionAnswer } from "models/test-detail.model";

interface PropTypes {
    question: TestDetailQuizModel;
    answers: TestQuestionAnswer[];
    handleUpdateQuestions: (newValue: TestDetailQuizModel) => void;
}

const DungSaiComponent: React.FC<PropTypes> = ({ question, handleUpdateQuestions, answers }) => {
  return (
    <div>
      {(answers || []).map((answer, index) => (
        <div className="question-content--item" key={`answer dung-sai${question.id}-${index}`}>
          <label htmlFor={`dung-sai${question.id}${index}`} className="custom-checkbox">
            <input
              type="radio"
              id={`dung-sai${question.id}${index}`}
              name={question?.id}
              value={answer?.answer}
              checked={+question?.userAnswer === index}
              onChange={() => {
                if (!Array.isArray(question.userAnswer)) {
                  question.userAnswer = [];
                }
                question.userAnswer[0] = answer?.order;
                handleUpdateQuestions({ ...question });
              }}
            />
            <span>{answer?.answer}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default memo(DungSaiComponent);
